import { j as r } from "./index.es33.js";
import { memo as e } from "react";
import { t as m } from "./index.es106.js";
import { clsx as t } from "./index.es105.js";
import { Typography as s } from "./index.es35.js";
import "./index.es36.js";
import { weeksMap as p } from "./index.es668.js";
import { weekDayTranslationKeys as a } from "./index.es529.js";
import i from "./index.es685.js";
import l from "./index.es640.js";
var D = /*#__PURE__*/e(function () {
  return r.jsx("thead", {
    children: r.jsx("tr", {
      children: p.map(function (o) {
        return r.jsx(s.Overline, {
          className: t(i.week, l.calendarDayHeaderItem),
          as: "th",
          children: m(a[o])
        }, o);
      })
    })
  });
});
export { D as Weeks };